import {logout} from '../../../firebase/auth';
import {saveReturnUrl} from '../../../shared/loginReturnUrl';

/** Query param shown on the login page after a collaboration/server reset. */
export const COLLAB_RESET_LOGOUT_REASON = 'collab-reset';
export const SERVICE_RESTART_LOGOUT_REASON = 'service-restart';

let logoutInProgress = false;

/**
 * Sign the user out and redirect to login so no stale in-memory Y.Doc can merge
 * with a freshly loaded server document after ws-collaboration restart/reset.
 */
export async function forceLogoutForCollaborationReset(meta = {}) {
    if (logoutInProgress || typeof window === 'undefined') {
        return;
    }
    logoutInProgress = true;

    console.warn('[collab] forcing sign-out after collaboration server reset', meta);

    saveReturnUrl();

    try {
        await logout();
    } catch (err) {
        console.warn('[collab] logout request failed; clearing local session anyway', err);
    }

    const reason = meta?.reason === SERVICE_RESTART_LOGOUT_REASON
        ? SERVICE_RESTART_LOGOUT_REASON
        : COLLAB_RESET_LOGOUT_REASON;
    const params = new URLSearchParams({logout: '', reason});
    window.location.replace(`${window.location.origin}/?${params.toString()}`);
}
